jQuery(function($){
    var $acc = $('.js-acc-menu');
    var $btn = $acc.find('.js-acc-menu__btn');
    var $content = $acc.find('.js-acc-menu__content');
    $content.css('display', 'none');

    $btn.click(function(e){
        var $this_btn = $(this);
        var $acc_item = $this_btn.closest('.js-acc-menu__item');
        var $acc_content = $acc_item.find('.js-acc-menu__content');
        if ($this_btn.hasClass('active')){
        }else{
            e.preventDefault();
            $this_btn.addClass('active');
            $acc_content.slideDown(400);
        }
    });
});